import React, { useState } from "react";
import { Layout, Menu, Button, Drawer, Grid, Dropdown } from "antd";
import { MenuOutlined, DownOutlined, BulbOutlined, BulbFilled } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "../contexts/ThemeContext";
import "./AppHeader.scss";

const { Header } = Layout;
const { useBreakpoint } = Grid;

const AppHeader: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const screens = useBreakpoint();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const changeLanguage = (lng: string) => {
    try {
      window.localStorage.setItem('userSelectedLanguage', lng);
    } catch {
      // ignore storage errors
    }
    i18n.changeLanguage(lng);
  };

  const menuItems = [
    { key: "/", label: <Link to="/">{t("home")}</Link> },
    { key: "/about", label: <Link to="/about">{t("about")}</Link> },
    { key: "/service", label: <Link to="/service">{t("service")}</Link> },
    { key: "/product", label: <Link to="/product">{t("product")}</Link> },
    { key: "/contact", label: <Link to="/contact">{t("contact")}</Link> },
    { key: "/cooperate", label: <Link to="/cooperate">{t("cooperate")}</Link> },
    { key: "/recruitment", label: <Link to="/recruitment">{t("recruitment")}</Link> },
  ];

  const languages = [
    { code: "en", label: "English" },
    { code: "fr", label: "Français" },
    { code: "ja", label: "日本語" },
    { code: "ko", label: "한국어" },
    { code: "vi", label: "Tiếng Việt" },
    { code: "zh", label: "中文" },
  ];

  const languageMenu = {
    items: languages.map((lng) => ({
      key: lng.code,
      label: lng.label,
      onClick: () => changeLanguage(lng.code),
    })),
  };

  // 👉 Lấy tên ngôn ngữ hiện tại
  const currentLangLabel =
    languages.find((l) => l.code === i18n.language)?.label || "English";

  return (
    <Header className="app-header">
      {/* LEFT — Logo */}
      <div className="header-left">
        <Link to="/">
          <img src="/asset/hy-logo.png" alt="HY Connect" />
        </Link>
      </div>

      {/* CENTER — Desktop Menu */}
      {screens.md && (
        <div className="header-center">
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            className="main-menu"
          />
        </div>
      )}

      {/* CENTER — Mobile Menu Button */}
      {!screens.md && (
        <div className="header-center-mobile">
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 22, color: theme === 'light' ? "#000" : "#fff" }} />}
            onClick={() => setOpen(true)}
          />
        </div>
      )}

      {/* RIGHT — Language and Theme */}
      <div className="header-right">
        <Button
          type="text"
          icon={theme === 'light' ? <BulbOutlined /> : <BulbFilled />}
          onClick={toggleTheme}
          style={{ color: theme === 'light' ? "#000" : "#fff", fontSize: 18 }}
        />
        <Dropdown menu={languageMenu} placement="bottomRight">
          <span className="lang-dropdown">
            {currentLangLabel} <DownOutlined />
          </span>
        </Dropdown>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title="Menu"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <Menu
          mode="vertical"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={() => setOpen(false)}
        />
      </Drawer>
    </Header>
  );
};

export default AppHeader;
